export default ".fancy-box[data-v-56ee784a] { z-index: 9999999999;\n}\n"